module.exports = __webpack_public_path__ + "img/mobile-menu.c5593ba7.svg";